export default __webpack_public_path__ + "images/coins-in-hand-outline-white.3ccfacd7e0c288379def308fc763f542.png";